import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AddSurveyCategory, getSurveyCategoryList, UpdateSurveyCategory } from "./SurveryCategorytRepo";
import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

interface surveyCategoryInterface{
    page?:number,
    limit?:number,
    search?:string,
    surveyFor?:string
}

export const useGetSurveyCategoryList = ({enable = false,params}: {enable: boolean;params:surveyCategoryInterface}) => {
  return useQuery({
    queryKey: ["GET_SURVEY_CATEGORY_LIST", params],
    queryFn: () => getSurveyCategoryList(params),
    enabled:enable,
    retry: false,
  });
};


interface ReqBody{
    SurveyCatName:string,
    Orgunitid:number[],
    SurveyFor?:string | null
    Status?:number
}

export const useAddSurveyCategory =()=>{
    
    const queryClient = useQueryClient();
    return useMutation({

        mutationFn:(ReqBody:ReqBody)=>AddSurveyCategory(ReqBody),
        onSuccess:()=>{
            showToast.success('Added Successfully')
            queryClient.invalidateQueries({queryKey:['GET_SURVEY_CATEGORY_LIST']});
            queryClient.invalidateQueries({queryKey:['GET_CATEGORY_TYPE']});

        },
        onError:(error:any)=>{
         console.log('Failed to Add ',error.message);
         showToast.error('Failed to Add',);
        }
    })
} 




export const useUpdateSurveyCategory =()=>{
    const queryClient = useQueryClient();
    return useMutation({

        mutationFn:({ReqBody,id}:{ReqBody:ReqBody,id:number})=>UpdateSurveyCategory(ReqBody,id),
        onSuccess:()=>{
            showToast.success('Updated Successfully');
            queryClient.invalidateQueries({queryKey:['GET_SURVEY_CATEGORY_LIST']});
        },
        onError:(error:any)=>{
         console.log('Failed to Update ',error.message);
         showToast.error('Failed to Update');
        }
    })
} 

